export default "__VITE_PUBLIC_ASSET__db21aa50__"